import React from "react";

import {
  InlineCreateSaleLotModal,
  InlineCreateSaleLotInitialValues,
  InlineCreateSaleLotOptions,
} from "components/InlineCreateSaleLotModal/index";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";

interface InlineCreateSaleLotModalHashParams {
  initialValues?: InlineCreateSaleLotInitialValues;
  options: InlineCreateSaleLotOptions;
}

function InlineCreateSaleLotModalAdapter(props: ModalAdapterProps) {
  const { hash } = props;
  const hashParams = hash[ModalTypes.InlineCreateSaleLot] || null;
  const { initialValues, options }: InlineCreateSaleLotModalHashParams =
    JSON.parse(hashParams);

  const decodedReturnTo = hash.returnTo ? atob(hash.returnTo) : "";
  return (
    <InlineCreateSaleLotModal
      returnTo={decodedReturnTo}
      initialValues={initialValues}
      options={options}
    />
  );
}

export default InlineCreateSaleLotModalAdapter;
